import { callFunction } from "./functions-client";

// Activity / Timeline (LOS Phase 4).
export interface Activity {
  id: number;
  verb: string;
  object_type: string | null;
  object_id: string | null;
  summary: string | null;
  visibility?: string;
  created_at: string;
  actor_account_id?: string;
  actor_profile_id?: string | null;
  actor_name?: string | null;
  actor_type?: string | null;
}

/** A profile's activity timeline (server filters by the viewer's relation). */
export const profileTimeline = (profile_id: string) =>
  callFunction<{ activities: Activity[] }>(`timeline/profile?profile_id=${encodeURIComponent(profile_id)}`, { method: "GET" });

/** The caller's network activity feed. */
export const networkFeed = () =>
  callFunction<{ activities: Activity[] }>("timeline/feed", { method: "GET" });

const VERB_ICON: Record<string, string> = {
  posted_job: "jobs", posted_load: "loads", got_verified: "verify",
  left_review: "star", connected: "connections", joined: "profile",
};
export const verbIcon = (verb: string) => VERB_ICON[verb] ?? "bell";
